var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { attachmentsKeys } from './queryKeys';
import { fetchAttachmentsList, deleteProposalAttachment, deleteProposalPhoto, detachBuildingPhoto, detachWorkOrderPhoto, removeReport, uploadFile } from '../services/AttachmentsService';
export function useAttachmentsList(proposalId, url) {
    return useQuery({
        queryKey: attachmentsKeys.list(proposalId),
        queryFn: () => fetchAttachmentsList(url),
        staleTime: 30 * 1000
    });
}
export function useRemoveAttachment(proposalId, opts) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (item) => __awaiter(this, void 0, void 0, function* () {
            if (item.sourceKind === 'upload') {
                if (item.id.startsWith('attachment-')) {
                    yield deleteProposalAttachment(opts.deleteAttachmentUrl, item.recordId);
                }
                else if (item.id.startsWith('photo-')) {
                    yield deleteProposalPhoto(opts.deleteProposalPhotoUrl, item.recordId);
                }
            }
            else {
                if (item.id.startsWith('report-') && item.reportId != null) {
                    yield removeReport(opts.removeReportUrl, item.reportId, proposalId);
                }
                else if (item.id.startsWith('building_photo-') && item.deficiencyPhotoId != null) {
                    yield detachBuildingPhoto(opts.detachBuildingPhotoUrl, item.deficiencyPhotoId);
                }
                else if (item.id.startsWith('wo_photo-') && item.workOrderPhotoId != null) {
                    yield detachWorkOrderPhoto(opts.detachWorkOrderPhotoUrl, item.workOrderPhotoId);
                }
            }
        }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: attachmentsKeys.list(proposalId) });
        }
    });
}
export function useUploadFile(proposalId, uploadUrl, csrfToken) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (file) => uploadFile(uploadUrl, file, csrfToken),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: attachmentsKeys.list(proposalId) });
        }
    });
}
